import React, { Suspense, FC } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Contribute from '../../components/company/contribute';
import Data from '../../components/company/data';
import Main from '../../components/company/main';
import Team from '../../components/company/team';
import Values from '../../components/company/values';
import PreFooter from '../../components/prefooter';

interface Props {}

const Company: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Suspense fallback={<div />}>
      <Helmet>
        <meta
          name="description"
          content="Our team excels in applying the latest techniques in Machine Learning and Data Science to solve real world problems that bring value to your business. Get to know us!"
        />
        <title>
          Mutt Data | Data Nerds is not just a slogan. Get to know our team and
          values.
        </title>
        <meta
          property="og:title"
          content="Mutt Data | Data Nerds is not just a slogan. Get to know our team and values."
        />
        <meta
          property="og:description"
          content="Our team excels in applying the latest techniques in Machine Learning and Data Science to solve real world problems that bring value to your business. Get to know us!"
        />
        <meta
          property="og:image"
          content={`https://muttdata.ai/email/logo.png`}
        />
        <meta property="og:url" content="https://muttdata.ai/company" />
        <meta
          name="keywords"
          content="
data nerds meetup
argentina big data
argentina data science
"
        />
      </Helmet>
      <Main />
      <Data />
      <Team />
      <Values />
      <Contribute />
      <PreFooter
        title={t('CompanyPrefooterTitle')}
        text={t('CompanyPrefooterText')}
        btnText={t('CompanyPrefooterButton')}
      />
    </Suspense>
  );
};

export default Company;
